'use client';

import {Box, styled} from '@mui/material';

export const StyledLanguageSwitcherContainer = styled(Box)(({ theme }) => ({
  display: 'none',

  [theme.breakpoints.up('headerAlignment')]: {
    display: 'flex',
  },
}));